<div class="modal-backdrop">
  <div class="modal-content" [ngClass]="{'modal-size-m': modalSize === 'M', 'modal-size-xl': modalSize === 'XL'}">
    <app-header-modal-header
      [title]="headerTitle"
      [color]="headerColor"
      [showClose]="true"
      (close)="close.emit()"
    ></app-header-modal-header>
    <div class="modal-body">
      <ng-content></ng-content>
    </div>
    <app-header-modal-footer
      [submitText]="footerSubmitText"
      [cancelText]="footerCancelText"
      [submitColor]="footerSubmitColor"
      [submitDisabled]="footerSubmitDisabled"
      (submit)="onSubmit()"
      (cancel)="close.emit()"
    ></app-header-modal-footer>
  </div>
</div>
